import React, { FC } from 'react'
import { SessionId } from '@afterpaytouch/identity'
import { useSessionId } from '../../state'
import { useAmplitude } from 'react-amplitude-hooks'
import { useTranslation } from '../../utils/convergence'
import { SessionIdVisibility } from '../../model'
import styles from './SessionIdContainer.module.css'

export const SessionIdContainer: FC = () => {
  const { t } = useTranslation()
  const { visibility } = useSessionId()
  const { amplitudeInstance } = useAmplitude()

  const isVisible = visibility === SessionIdVisibility.VISIBLE
  const rawSessionId = amplitudeInstance?.getSessionId()?.toString() ?? ''

  // Container handles translation - component just displays
  const formattedSessionId = t('common:sessionId', { sessionId: rawSessionId })

  return <SessionId sessionId={formattedSessionId} isVisible={isVisible} className={styles.text} />
}
